import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { getAllImgs } from '@shared/utils'
import ResponsiveImage from '@shared/components/responsiveImage'
import CustomLink from '@shared/components/customLink'
import { NoteIcon } from '@shared/components/ctIcons'

function ArticleAlsoRead({ data, article, fantasyArticle }) {
  const articleId = data?.oProps?.id?.split('-') || []
  const fantasyId = data?.oProps?.['data-fantasy-id']?.split('-') || []
  if (data?.oProps?.['data-url']) {
    return (
      <div className={`d-flex align-items-center flex-wrap flex-md-nowrap my-3 p-2 rounded-2 gap-1 ${styles.link}`}>
        <span className="flex-shrink-0" style={{ width: '20px' }}>
          <NoteIcon />
        </span>
        <span className="flex-shrink-0">{data?.oProps?.['data-label-text'] || 'Also Read'}:</span>
        <CustomLink href={`/${data?.oProps?.['data-url']}` || ''} className="overflow-hidden t-ellipsis w-100 w-md-auto" prefetch={false}>
          {data?.oProps?.['data-title'] || data?.oProps?.['data-url']}
        </CustomLink>
      </div>
    )
  } else if (articleId?.length || fantasyId?.length) {
    return (
      <div className={`d-flex flex-column flex-md-row gap-2 ${articleId?.length > 0 ? 'mt-3 mb-3' : ''}`}>
        {articleId?.map((id) => {
          const ar = article?.find((item) => item?._id === id)
          if (ar?._id) {
            const { small, mainURL } = getAllImgs(ar?.oTImg?.sUrl || ar?.oImg?.sUrl)
            return (
              <div
                key={id}
                className={`${styles.articleRead} d-flex flex-row align-items-md-center gap-2 br-sm flex-grow-1 position-relative`}
              >
                <CustomLink href={`/${ar?.oSeo?.sSlug}`} className="position-absolute top-0 start-0 h-100 w-100 d-block opacity-0">
                  {ar?.sSrtTitle || ar?.sTitle}
                </CustomLink>
                <div className={`${styles.articleLeft} flex-shrink `}>
                  <ResponsiveImage
                    className="mb-0 br-sm"
                    height="66"
                    width="108"
                    src={small}
                    errorSrc={mainURL}
                    alt={ar?.oImg?.sText || ar?.sSrtTitle || ar?.sTitle}
                  />
                </div>
                <div className={`${styles.articleRight} flex-grow-1 `}>
                  <span>{data?.oProps?.['data-label-text'] || 'Also Read'}</span>
                  <p>{ar?.sSrtTitle || ar?.sTitle}</p>
                </div>
              </div>
            )
          } else return null
        })}
        {fantasyId?.map((id) => {
          const ar = fantasyArticle?.find((item) => item?._id === id)
          if (ar?._id) {
            const { small, mainURL } = getAllImgs(ar?.oTImg?.sUrl || ar?.oImg?.sUrl)
            return (
              <div
                key={id}
                className={`${styles.articleRead} d-flex flex-row align-items-md-center gap-2 br-sm flex-grow-1 position-relative`}
              >
                <CustomLink href={`/${ar?.oSeo?.sSlug}`} className="position-absolute top-0 start-0 h-100 w-100 d-block opacity-0">
                  {ar?.sSrtTitle || ar?.sTitle}
                </CustomLink>
                <div className={`${styles.articleLeft} flex-shrink `}>
                  <ResponsiveImage
                    className="mb-0 br-sm"
                    height="66"
                    width="108"
                    src={small}
                    errorSrc={mainURL}
                    alt={ar?.oImg?.sText || ar?.sSrtTitle || ar?.sTitle}
                  />
                </div>
                <div className={`${styles.articleRight} flex-grow-1 `}>
                  <span>{data?.oProps?.['data-label-text'] || 'Also Read'}</span>
                  <p>{ar?.sSrtTitle || ar?.sTitle}</p>
                </div>
              </div>
            )
          } else return null
        })}
      </div>
    )
  } else return null
}
ArticleAlsoRead.propTypes = {
  data: PropTypes.object,
  article: PropTypes.array,
  fantasyArticle: PropTypes.array
}
export default ArticleAlsoRead
